import React from 'react'
import { Route, Redirect } from 'react-router'
import { connect } from 'react-redux'

class PrivateRoute extends React.Component {
    render() {
        const {
            authenticated,
            component: Component,
            ...props
        } = this.props

        return (
            <Route
                {...props}
                render={props =>
                    authenticated
                        ? <Component {...props} />
                        : (
                            <Redirect to={{
                                pathname: '/login',
                                state: { from: props.location }
                            }} />
                        )
                }
            />
        )
    }
}

const mapStateToProps = s => ({ authenticated: s.authReducer.authenticated });

export default connect(mapStateToProps)(PrivateRoute)




// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js